/* ez-doc-toc.js — instance-safe auto-TOC + scroll-spy for ez-doc-with-toc.
   For each [data-ez-doc] root: numbers the body h2s, slugs+anchors them, builds the "Contents"
   nav (when [data-ez-doc-auto] is present — i.e. rendering page.content), and highlights the
   active section on scroll. Manual section blocks already carry their own ids + nav; this only
   augments the auto (page.content) body. Respects prefers-reduced-motion (no smooth extras). */
(function () {
  'use strict';

  function slugify(s, used) {
    var base = String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '') || 'section';
    var id = base, n = 2;
    while (used[id]) { id = base + '-' + n; n++; }
    used[id] = true;
    return id;
  }

  function initRoot(root) {
    var body = root.querySelector('[data-ez-doc-body]');
    var nav = root.querySelector('[data-ez-doc-nav]');
    if (!body) return;

    var auto = body.hasAttribute('data-ez-doc-auto');
    var used = {};
    // Pre-register any manual-section ids so auto ids don't collide.
    var pre = root.querySelectorAll('[data-ez-doc-section][id]');
    for (var p = 0; p < pre.length; p++) { used[pre[p].id] = true; }

    var links = [];

    if (auto && nav) {
      var h2s = body.querySelectorAll('h2');
      var i;
      for (i = 0; i < h2s.length; i++) {
        var h = h2s[i];
        // capture heading text BEFORE injecting the number span. A heading that itself starts with
        // a digit (e.g. "3M™ VHB adhesive bond") lost it when we stripped a leading \d+ off the
        // combined "05" + "3M…" text — grab the clean label first, so no stripping is needed.
        var label = (h.textContent || '').trim();
        if (!h.id) { h.id = slugify(label, used); }
        h.classList.add('ez-doc__h2');
        h.setAttribute('data-ez-doc-section', '');
        var num = document.createElement('span');
        num.className = 'ez-doc__h2-num';
        num.setAttribute('aria-hidden', 'true');
        num.textContent = String(i + 1).length < 2 ? '0' + (i + 1) : String(i + 1);
        h.insertBefore(num, h.firstChild);

        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.className = 'ez-doc__toc-link';
        a.textContent = label;
        nav.appendChild(a);
        links.push(a);
      }
    } else {
      // manual blocks: nav links already in the DOM
      var manual = nav ? nav.querySelectorAll('.ez-doc__toc-link') : [];
      for (var m = 0; m < manual.length; m++) { links.push(manual[m]); }
    }

    // No TOC entries (e.g. a page.content body with no <h2>s, like the CCPA opt-out page) — drop the
    // rail so the layout doesn't show a bare "Contents" column. CSS collapses the grid to full-width.
    if (!links.length) { root.classList.add('ez-doc--no-toc'); return; }

    var byId = {};
    for (var k = 0; k < links.length; k++) {
      var href = links[k].getAttribute('href') || '';
      byId[href.replace('#', '')] = links[k];
    }

    var sections = root.querySelectorAll('[data-ez-doc-section][id]');
    if (!('IntersectionObserver' in window) || !sections.length) return;

    var obs = new IntersectionObserver(function (entries) {
      var vis = entries.filter(function (e) { return e.isIntersecting; })
        .sort(function (a, b) { return a.boundingClientRect.top - b.boundingClientRect.top; });
      if (!vis[0]) return;
      var id = vis[0].target.id;
      for (var key in byId) {
        if (Object.prototype.hasOwnProperty.call(byId, key)) {
          byId[key].classList.toggle('is-active', key === id);
        }
      }
    }, { rootMargin: '-15% 0px -72% 0px' });

    for (var s = 0; s < sections.length; s++) { obs.observe(sections[s]); }
  }

  function init() {
    var roots = document.querySelectorAll('[data-ez-doc]');
    for (var i = 0; i < roots.length; i++) { initRoot(roots[i]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
